module.exports = __webpack_public_path__ + "static/media/logorisa.d5ae7577.png";